import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { TableCell, TableRow } from '@mui/material';

const ApprovalHistoryComponent = ({ approval, t }) => {
  return (
    <TableRow key={approval.documentApprovalsHistoryId}>
      <TableCell>{approval.documentNumber}</TableCell>

      <TableCell>{approval.approvalTypeName}</TableCell>

      <TableCell>{approval.approvalLevelName}</TableCell>

      <TableCell>{approval.approvalStatusName}</TableCell>

      <TableCell>{approval.comment}</TableCell>

      <TableCell>{approval.addedByName}</TableCell>

      <TableCell>{approval.updatedOn ? t('DATE_FORMAT', { date: { value: approval.updatedOn, format: 'DD MMMM YYYY' } }) : ''}</TableCell>

      <TableCell>{approval.updatedByName}</TableCell>

      <TableCell>
        {approval.dateApprovalChanged ? t('DATE_FORMAT', { date: { value: approval.dateApprovalChanged, format: 'DD MMMM YYYY' } }) : ''}
      </TableCell>
      <TableCell>{approval.advancePercent}</TableCell>
      <TableCell>{approval.durationMonths}</TableCell>
      <TableCell>{approval.residualValuePercent}</TableCell>
    </TableRow>
  );
};

ApprovalHistoryComponent.propTypes = {
  t: PropTypes.func.isRequired,
  approval: PropTypes.object.isRequired
};

export default withTranslation()(ApprovalHistoryComponent);
